import { MatchResponse } from 'api/responseTypes';
import { EventHeader } from 'components/EventHeader/EventHeader';

type GameInfoProps = MatchResponse;

export const GameInfo = ({
  date,
  time,
  stadium,
  teamA,
  teamB,
  city,
  arDescription,
  location,
  eventKey,
  title,
  isFreeEvent,
  hasTimeslots,
}: GameInfoProps) => {
  const eventName =
    teamA?.name && teamB?.name ? `${teamA.name} vs ${teamB.name}` : title || eventKey;

  return (
    <EventHeader
      variant='match'
      date={date}
      time={time}
      stadium={stadium}
      teamA={teamA}
      teamB={teamB}
      city={city}
      arDescription={arDescription}
      locationHtml={location}
      eventKey={eventKey}
      eventName={eventName}
      isFreeEvent={isFreeEvent}
      hasTimeslots={hasTimeslots}
    />
  );
};
